import React, { useState, useEffect } from 'react';
import { Card, Button, Input, Select, message, Row, Col, Table, InputNumber, Space, Divider, Tag, Popconfirm, Form, Modal, DatePicker, Upload } from 'antd';
import { ArrowLeftOutlined, PlusOutlined, DeleteOutlined, FilePdfOutlined, SaveOutlined, DollarOutlined, StopOutlined, DownloadOutlined, MailOutlined, ReloadOutlined, FileProtectOutlined, EditOutlined, UploadOutlined } from '@ant-design/icons';
import { useNavigate, useParams, useSearchParams } from 'react-router-dom';
import api from '../services/api';
import { PainelAssinaturas, BotoesAssinatura } from '../components/AssinaturaProposta';
const { Option: OptionComp } = Select;

const { Option } = Select;
const { TextArea } = Input;

const CONDICOES = ['À vista', '15 dias', '30 dias', '30/60 dias', '30/60/90 dias', 'Entrada + 30 dias', 'Boleto 30 dias', 'Cartão de crédito', 'PIX'];
const FRETES = ['a_combinar', 'cif', 'fob', 'correios', 'transportadora_cliente', 'retirada'];
const FRETE_LABELS = { a_combinar: 'A combinar', cif: 'CIF (por nossa conta)', fob: 'FOB (por conta do cliente)', correios: 'Correios', transportadora_cliente: 'Transportadora do cliente', retirada: 'Retirada no local' };

const fmtMoeda = v => v ? 'R$ ' + parseFloat(v).toLocaleString('pt-BR', { minimumFractionDigits: 2 }) : 'R$ 0,00';

export default function PropostaProduto() {
  const { id } = useParams();
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const cliente_id = searchParams.get('cliente_id');

  const [proposta, setProposta] = useState(null);
  const [cliente, setCliente] = useState(null);
  const [cnpjs, setCnpjs] = useState([]);
  const [contatos, setContatos] = useState([]);
  const [produtos, setProdutos] = useState([]);
  const [itens, setItens] = useState([]);
  const [salvando, setSalvando] = useState(false);

  const [cnpjId, setCnpjId] = useState(null);
  const [contatoId, setContatoId] = useState(null);
  const [condicaoPagamento, setCondicaoPagamento] = useState('');
  const [frete, setFrete] = useState('a_combinar');
  const [observacoes, setObservacoes] = useState('');
  const [impostosPercentual, setImpostosPercentual] = useState(0);
  const [descontoPercentual, setDescontoPercentual] = useState(0);
  const [descontoValor, setDescontoValor] = useState(0);
  const [validadeDias, setValidadeDias] = useState(15);
  const [gerandoPDF, setGerandoPDF] = useState(false);
  const [boletos, setBoletos] = useState([]);
  const [nfes, setNfes] = useState([]);
  const [modalNFe, setModalNFe] = useState(false);
  const [emitindoNFe, setEmitindoNFe] = useState(false);
  const [nfesCanceladas, setNfesCanceladas] = useState([]);
  const [chaveSubstituta, setChaveSubstituta] = useState(null);
  const [movimentarEstoque, setMovimentarEstoque] = useState(false);
  const [depositos, setDepositos] = useState([]);
  const [depositoNFe, setDepositoNFe] = useState(null);
  const [modalComplementar, setModalComplementar] = useState(false);
  const [nfeSelecionada, setNfeSelecionada] = useState(null);
  const [itensComplementar, setItensComplementar] = useState([]);
  const [infAdicComplementar, setInfAdicComplementar] = useState('');
  const [emitindoComplementar, setEmitindoComplementar] = useState(false);
  const [produtosComplementar, setProdutosComplementar] = useState([]);
  const [infAdic, setInfAdic] = useState('');
  const [modalBoleto, setModalBoleto] = useState(false);
  const [formBoleto] = Form.useForm();
  const [gerandoBoleto, setGerandoBoleto] = useState(false);
  const [modalDadosBoleto, setModalDadosBoleto] = useState(false);
  const [dadosBoleto, setDadosBoleto] = useState(null);
  const [modalCancelar, setModalCancelar] = useState(false);
  const [boletoCancelarId, setBoletoCancelarId] = useState(null);
  const [motivoCancelamento, setMotivoCancelamento] = useState('ACERTOS');
  const [ordemCompra, setOrdemCompra] = useState('');
  const [uploadingOC, setUploadingOC] = useState(false);
  const [titulo, setTitulo] = useState('');

  useEffect(() => { carregar(); }, [id, cliente_id]);

  const carregar = async () => {
    try {
      const [rProdutos] = await Promise.all([api.get('/produtos')]);
      setProdutos(rProdutos.data);

      if (id) {
        api.get('/boletos/proposta/' + id + '?tipo=produto').then(rb => setBoletos(rb.data || [])).catch(() => {});
        api.get('/nfe/proposta-produto/' + id).then(rn => setNfes(rn.data || [])).catch(() => {});
        const r = await api.get('/propostas-produtos/' + id);
        setProposta(r.data);
        setItens(r.data.itens || []);
        setCnpjId(r.data.cnpj_id);
        setContatoId(r.data.contato_id);
        setCondicaoPagamento(r.data.condicao_pagamento || '');
        setFrete(r.data.frete || 'a_combinar');
        setObservacoes(r.data.observacoes || '');
        setTitulo(r.data.titulo || '');
        setOrdemCompra(r.data.ordem_compra || '');
        setImpostosPercentual(parseFloat(r.data.impostos_percentual) || 0);
        setDescontoPercentual(parseFloat(r.data.desconto_percentual) || 0);
        setDescontoValor(parseFloat(r.data.desconto_valor) || 0);
        setValidadeDias(r.data.validade_dias || 15);
        await carregarCliente(r.data.cliente_id);
      } else if (cliente_id) {
        await carregarCliente(cliente_id);
      }
    } catch(e) { message.error('Erro ao carregar dados'); }
  };

  const carregarCliente = async (cid) => {
    const [rCli, rCnpjs, rContatos] = await Promise.all([
      api.get('/clientes/' + cid),
      api.get('/clientes/' + cid + '/cnpjs'),
      api.get('/clientes/' + cid + '/contatos'),
    ]);
    setCliente(rCli.data);
    setCnpjs(rCnpjs.data || []);
    setContatos(rContatos.data || []);
  };

  const adicionarItem = () => {
    setItens([...itens, { id: Date.now(), produto_id: null, descricao: '', quantidade: 1, unidade: 'Unidade', preco_unitario: 0, prazo_entrega: '' }]);
  };

  const atualizarItem = (idx, campo, valor) => {
    const novos = [...itens];
    novos[idx] = { ...novos[idx], [campo]: valor };
    if (campo === 'produto_id' && valor) {
      const prod = produtos.find(p => p.id === valor);
      if (prod) {
        novos[idx].descricao = prod.descricao;
        novos[idx].unidade = prod.unidade || 'Unidade';
        novos[idx].preco_unitario = prod.preco_venda || 0;
      }
    }
    setItens(novos);
  };

  const removerItem = (idx) => setItens(itens.filter((_, i) => i !== idx));

  const subtotal = itens.reduce((s, i) => s + (parseFloat(i.preco_unitario) || 0) * (parseFloat(i.quantidade) || 0), 0);
  const valorImpostos = subtotal * (impostosPercentual / 100);
  const valorDesconto = subtotal * ((parseFloat(descontoPercentual) || 0) / 100) + (parseFloat(descontoValor) || 0);
  const total = Math.max(0, subtotal - valorDesconto);

  const uploadOC = async (file) => {
    if (!id) { message.warning('Salve a proposta primeiro'); return false; }
    try {
      setUploadingOC(true);
      const formData = new FormData();
      formData.append('arquivo', file);
      await api.post('/upload/propostas-produtos/' + id + '/oc', formData, { headers: { 'Content-Type': 'multipart/form-data' } });
      message.success('Arquivo da OC enviado!');
      const r = await api.get('/propostas-produtos/' + id);
      setProposta(r.data);
    } catch(e) { message.error('Erro ao enviar: ' + (e.response?.data?.erro || e.message)); }
    finally { setUploadingOC(false); }
    return false;
  };

  const verArquivoOC = async () => {
    try {
      const token = localStorage.getItem('token');
      const response = await fetch('/api/upload/propostas-produtos/' + id + '/oc', { headers: { Authorization: 'Bearer ' + token } });
      if (!response.ok) throw new Error('Arquivo não encontrado');
      const blob = await response.blob();
      window.open(URL.createObjectURL(blob), '_blank');
    } catch(e) { message.error('Arquivo não encontrado'); }
  };

  const salvar = async (status = 'rascunho') => {
    if (!cliente_id && !proposta?.cliente_id) { message.warning('Cliente não identificado'); return; }
    if (itens.length === 0) { message.warning('Adicione pelo menos um item'); return; }
    setSalvando(true);
    try {
      const payload = {
        cliente_id: cliente_id || proposta?.cliente_id,
        titulo,
        ordem_compra: ordemCompra,
        cnpj_id: cnpjId, contato_id: contatoId, status,
        validade_dias: validadeDias, condicao_pagamento: condicaoPagamento,
        frete, observacoes, impostos_percentual: impostosPercentual,
        desconto_percentual: parseFloat(descontoPercentual) || 0, desconto_valor: parseFloat(descontoValor) || 0,
        itens: itens.map((it, i) => ({ ...it, ordem: i }))
      };
      if (id) {
        await api.put('/propostas-produtos/' + id, payload);
        message.success('Proposta atualizada!');
      } else {
        const r = await api.post('/propostas-produtos', payload);
        message.success('Proposta criada!');
        navigate('/propostas-produtos/' + r.data.id);
      }
    } catch(e) { message.error('Erro ao salvar: ' + (e.response?.data?.erro || e.message)); }
    finally { setSalvando(false); }
  };

  const emitirBoleto = async (values) => {
    try {
      setGerandoBoleto(true);
      await api.post('/boletos/proposta/' + id, {
        vencimento: values.vencimento?.format('YYYY-MM-DD'),
        valor: values.valor || total,
        tipo_boleto: values.tipo_boleto || 'unico',
        multa_percentual: values.multa_percentual || 5,
        juros_percentual: values.juros_percentual || 2,
        desconto_percentual: values.desconto_percentual || 0,
        codigo_controle: values.codigo_controle,
        descricao: values.descricao,
        tipo: 'produto',
      });
      message.success('Boleto emitido com sucesso!');
      setModalBoleto(false);
      const r = await api.get('/boletos/proposta/' + id + '?tipo=produto');
      setBoletos(r.data || []);
    } catch(e) { message.error('Erro ao emitir boleto: ' + (e.response?.data?.erro || e.message)); }
    finally { setGerandoBoleto(false); }
  };

  const verBoleto = async (boletoId) => {
    try {
      const r = await api.get('/boletos/' + boletoId + '/pdf');
      setDadosBoleto(r.data);
      setModalDadosBoleto(true);
    } catch { message.error('Erro ao abrir boleto'); }
  };

  const baixarPDFBoleto = async (boletoId) => {
    try {
      message.loading({ content: 'Gerando PDF...', key: 'pdfboleto', duration: 0 });
      const r = await api.get('/boletos/' + boletoId + '/pdf/gerar', { responseType: 'blob' });
      const url = window.URL.createObjectURL(new Blob([r.data], { type: 'application/pdf' }));
      window.open(url, '_blank');
      message.success({ content: 'PDF gerado!', key: 'pdfboleto' });
    } catch { message.error({ content: 'Erro ao gerar PDF', key: 'pdfboleto' }); }
  };

  const reenviarEmail = async (boletoId) => {
    try {
      await api.post('/boletos/' + boletoId + '/reenviar-email');
      message.success('Email reenviado!');
    } catch { message.error('Erro ao reenviar email'); }
  };

  const consultarStatus = async (boletoId) => {
    try {
      await api.get('/boletos/' + boletoId + '/status');
      message.success('Status atualizado!');
      const r = await api.get('/boletos/proposta/' + id + '?tipo=produto');
      setBoletos(r.data || []);
    } catch { message.error('Erro ao consultar status'); }
  };

  const cancelarBoleto = async () => {
    try {
      await api.post('/boletos/' + boletoCancelarId + '/cancelar', { motivo: motivoCancelamento });
      message.success('Boleto cancelado!');
      setModalCancelar(false);
      const r = await api.get('/boletos/proposta/' + id + '?tipo=produto');
      setBoletos(r.data || []);
    } catch(e) { message.error('Erro ao cancelar: ' + (e.response?.data?.erro || e.message)); }
  };

  const abrirModalNFe = async () => {
    const canceladas = nfes.filter(n => n.status === 'cancelada');
    setNfesCanceladas(canceladas);
    const rdep = await api.get('/estoque/depositos');
    setDepositos(rdep.data || []);
    if (rdep.data?.length > 0) setDepositoNFe(rdep.data[0].id);
    setMovimentarEstoque(false);
    setChaveSubstituta(null);
    // Recarregar proposta para pegar dados atualizados
    const rp = await api.get('/propostas-produtos/' + id);
    const oc = rp.data.ordem_compra;
    setInfAdic(oc ? 'OC: ' + oc : '');
    setModalNFe(true);
  };

  const abrirComplementar = async (nfe) => {
    setNfeSelecionada(nfe);
    setItensComplementar([{ produto_id: null, descricao: '', quantidade: 1, unidade: 'UN', preco_unitario: 0, ncm: '', origem: 0, avulso: false }]);
    setInfAdicComplementar('Nota Complementar referente NF-e ' + nfe.chave_acesso);
    const rp = await api.get('/produtos');
    setProdutosComplementar(rp.data || []);
    setModalComplementar(true);
  };

  const emitirComplementar = async () => {
    setEmitindoComplementar(true);
    try {
      await api.post('/nfe/' + nfeSelecionada.id + '/complementar', { itens: itensComplementar, infAdic: infAdicComplementar });
      message.success('NF-e Complementar emitida!');
      setModalComplementar(false);
      const rn = await api.get('/nfe/proposta-produto/' + id);
      setNfes(rn.data || []);
    } catch(e) { message.error('Erro: ' + (e.response?.data?.erro || e.message)); }
    finally { setEmitindoComplementar(false); }
  };

  const emitirNFe = async () => {
    setEmitindoNFe(true);
    try {
      await api.post('/nfe/proposta-produto/' + id, { chaveSubstituta: chaveSubstituta || undefined, infAdic: infAdic || undefined });
      const rn = await api.get('/nfe/proposta-produto/' + id);
      setNfes(rn.data || []);
      setModalNFe(false);
      message.success('NF-e emitida com sucesso!');
      // Movimentar estoque se solicitado
      if (movimentarEstoque && depositoNFe) {
        for (const item of itens) {
          if (item.produto_id && item.quantidade > 0) {
            try {
              await api.post('/estoque/movimentar', {
                produto_id: item.produto_id,
                deposito_id: depositoNFe,
                tipo: 'saida',
                quantidade: item.quantidade,
                motivo: 'Venda - NF-e emitida',
              });
            } catch(e) { console.error('Erro estoque:', e.message); }
          }
        }
        message.success('Estoque atualizado!');
      }
    } catch(e) { message.error('Erro ao emitir NF-e: ' + (e.response?.data?.erro || e.message)); }
    finally { setEmitindoNFe(false); }
  };

  const gerarPDF = async () => {
    setGerandoPDF(true);
    try {
      const r = await api.get('/propostas-produtos/' + (id || proposta?.id) + '/pdf', { responseType: 'blob' });
      const url = window.URL.createObjectURL(new Blob([r.data], { type: 'application/pdf' }));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', 'Proposta-' + proposta?.numero + '.pdf');
      document.body.appendChild(link);
      link.click();
      link.remove();
    } catch { message.error('Erro ao gerar PDF'); }
    finally { setGerandoPDF(false); }
  };

  const colunas = [
    { title: 'Produto', width: 220, render: (_, r, idx) => (
      <Select showSearch optionFilterProp="children" style={{ width: '100%' }} value={r.produto_id} allowClear placeholder="Selecione ou deixe livre"
        onChange={v => atualizarItem(idx, 'produto_id', v)}>
        {produtos.map(p => <Option key={p.id} value={p.id}>{p.descricao}</Option>)}
      </Select>
    )},
    { title: 'Descrição', render: (_, r, idx) => (
      <Input value={r.descricao} onChange={e => atualizarItem(idx, 'descricao', e.target.value)} placeholder="Descrição do item" />
    )},
    { title: 'Qtd', width: 80, render: (_, r, idx) => (
      <InputNumber style={{ width: '100%' }} min={0} precision={3} value={r.quantidade} onChange={v => atualizarItem(idx, 'quantidade', v)} />
    )},
    { title: 'Un', width: 80, render: (_, r, idx) => (
      <Input value={r.unidade} onChange={e => atualizarItem(idx, 'unidade', e.target.value)} />
    )},
    { title: 'Preço Unit.', width: 120, render: (_, r, idx) => (
      <InputNumber style={{ width: '100%' }} min={0} precision={2} value={r.preco_unitario} onChange={v => atualizarItem(idx, 'preco_unitario', v)} prefix="R$" decimalSeparator="," />
    )},
    { title: 'Total', width: 110, render: (_, r) => fmtMoeda((r.preco_unitario || 0) * (r.quantidade || 0)) },
    { title: 'Prazo', width: 120, render: (_, r, idx) => (
      <Input value={r.prazo_entrega} onChange={e => atualizarItem(idx, 'prazo_entrega', e.target.value)} placeholder="Ex: 5 dias úteis" />
    )},
    { title: '', width: 50, render: (_, r, idx) => (
      <Popconfirm title="Remover item?" onConfirm={() => removerItem(idx)}>
        <Button size="small" danger icon={<DeleteOutlined />} />
      </Popconfirm>
    )},
  ];

  return (
    <div>
      <PainelAssinaturas tipo="produto" id={id} proposta={proposta}
        onMudou={carregar} />
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 16 }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
          <Button icon={<ArrowLeftOutlined />} onClick={() => navigate('/clientes/' + (cliente_id || proposta?.cliente_id))}>Voltar</Button>
          <h2 style={{ margin: 0 }}>{id ? 'Proposta ' + proposta?.numero : 'Nova Proposta de Produto'}</h2>
          {proposta?.status && (
            <Select value={proposta.status} style={{ width: 140 }} onChange={async v => {
              await api.put('/propostas-produtos/' + id, { ...proposta, status: v, itens });
              setProposta({ ...proposta, status: v });
              message.success('Status atualizado!');
            }}>
              <Option value="rascunho">Rascunho</Option>
              <Option value="enviada">Enviada</Option>
              <Option value="aprovada">Aprovada</Option>
              <Option value="recusada">Recusada</Option>
              <Option value="faturada">Faturada</Option>
              <Option value="nf_enviada">NF Enviada</Option>
            </Select>
          )}
        </div>
        <Space>
          <Button icon={<SaveOutlined />} onClick={() => salvar(proposta?.status || 'rascunho')} loading={salvando}>Salvar</Button>
          {id && <Button icon={<FilePdfOutlined />} type="primary" onClick={gerarPDF} loading={gerandoPDF}>Gerar PDF</Button>}
          <BotoesAssinatura tipo="produto" id={id} proposta={proposta} />
        </Space>
      </div>

      <div style={{ marginBottom: 12 }}>
        <label style={{ fontSize: 12, color: '#888' }}>Título da Proposta</label>
        <Input value={titulo} onChange={e => setTitulo(e.target.value)} placeholder='Ex: Fornecimento de válvulas de segurança' size='large' />
      </div>
      <Row gutter={16} style={{ marginBottom: 16 }}>
        <Col span={12}>
          <Card title="Cliente" size="small">
            <p><strong>{cliente?.razao_social || cliente?.nome}</strong></p>
            <Row gutter={8}>
              <Col span={12}>
                <div style={{ marginBottom: 8 }}>
                  <label style={{ fontSize: 12, color: '#888' }}>CNPJ Faturamento</label>
                  <Select style={{ width: '100%' }} value={cnpjId} onChange={setCnpjId} allowClear placeholder="Selecione o CNPJ">
                    {cnpjs.map(c => <Option key={c.id} value={c.id}>{c.cnpj} — {c.razao_social || c.cidade}</Option>)}
                  </Select>
                </div>
              </Col>
              <Col span={12}>
                <div style={{ marginBottom: 8 }}>
                  <label style={{ fontSize: 12, color: '#888' }}>Contato</label>
                  <Select style={{ width: '100%' }} value={contatoId} onChange={setContatoId} allowClear placeholder="Selecione o contato">
                    {contatos.map(c => <Option key={c.id} value={c.id}>{c.nome}</Option>)}
                  </Select>
                </div>
              </Col>
            </Row>
          </Card>
        </Col>
        <Col span={12}>
          <Card title="Condições Comerciais" size="small">
            <Row gutter={8}>
              <Col span={12}>
                <div style={{ marginBottom: 8 }}>
                  <label style={{ fontSize: 12, color: '#888' }}>Condição de Pagamento</label>
                  <Select style={{ width: '100%' }} value={condicaoPagamento} onChange={setCondicaoPagamento} allowClear>
                    {CONDICOES.map(c => <Option key={c} value={c}>{c}</Option>)}
                  </Select>
                </div>
              </Col>
              <Col span={12}>
                <div style={{ marginBottom: 8 }}>
                  <label style={{ fontSize: 12, color: '#888' }}>Frete</label>
                  <Select style={{ width: '100%' }} value={frete} onChange={setFrete}>
                    {FRETES.map(f => <Option key={f} value={f}>{FRETE_LABELS[f]}</Option>)}
                  </Select>
                </div>
              </Col>
              <Col span={12}>
                <div style={{ marginBottom: 8 }}>
                  <label style={{ fontSize: 12, color: '#888' }}>Validade (dias)</label>
                  <InputNumber style={{ width: '100%' }} value={validadeDias} onChange={setValidadeDias} min={1} />
                </div>
              </Col>
              <Col span={12}>
                <div style={{ marginBottom: 8 }}>
                  <label style={{ fontSize: 12, color: '#888' }}>Ordem de Compra (OC)</label>
                  <div style={{ display: 'flex', gap: 8 }}>
                    <Input value={ordemCompra} onChange={e => setOrdemCompra(e.target.value)} placeholder='Nº da OC do cliente' />
                    {proposta?.arquivo_oc && <Button size="small" onClick={verArquivoOC}>Ver OC</Button>}
                    <Upload beforeUpload={uploadOC} showUploadList={false} accept=".pdf,.jpg,.jpeg,.png">
                      <Button size="small" icon={<UploadOutlined />} loading={uploadingOC}>Anexar OC</Button>
                    </Upload>
                  </div>
                </div>
              </Col>
              <Col span={12}>
                <div style={{ marginBottom: 8 }}>
                  <label style={{ fontSize: 12, color: '#888' }}>Impostos (%)</label>
                  <InputNumber style={{ width: '100%' }} value={impostosPercentual} onChange={setImpostosPercentual} min={0} max={100} precision={2} decimalSeparator="," />
                </div>
                <Row gutter={8}>
                  <Col span={12}>
                    <div style={{ marginBottom: 8 }}>
                      <label style={{ fontSize: 12, color: '#888' }}>Desconto (%)</label>
                      <InputNumber style={{ width: '100%' }} value={descontoPercentual} onChange={(v) => setDescontoPercentual(v || 0)} min={0} max={100} precision={2} decimalSeparator="," />
                    </div>
                  </Col>
                  <Col span={12}>
                    <div style={{ marginBottom: 8 }}>
                      <label style={{ fontSize: 12, color: '#888' }}>Desconto (R$)</label>
                      <InputNumber style={{ width: '100%' }} value={descontoValor} onChange={(v) => setDescontoValor(v || 0)} min={0} precision={2} decimalSeparator="," />
                    </div>
                  </Col>
                </Row>
              </Col>
            </Row>
          </Card>
        </Col>
      </Row>

      <Card size="small" style={{ marginBottom: 16 }} title="Itens da Proposta"
        extra={<Button type="primary" icon={<PlusOutlined />} size="small" onClick={adicionarItem}>Adicionar Item</Button>}>
        <Table columns={colunas} dataSource={itens} rowKey="id" size="small" pagination={false}
          locale={{ emptyText: 'Nenhum item adicionado. Clique em "Adicionar Item".' }} />
        {itens.length > 0 && (
          <div style={{ textAlign: 'right', marginTop: 12, padding: '8px 16px', background: '#f5f5f5', borderRadius: 6 }}>
            <div>Subtotal: <strong>{fmtMoeda(subtotal)}</strong></div>
            {valorDesconto > 0 && <div style={{ color: '#c0392b' }}>Desconto{descontoPercentual > 0 ? ` (${descontoPercentual}%)` : ''}: <strong>- {fmtMoeda(valorDesconto)}</strong></div>}
            {impostosPercentual > 0 && <div style={{ color: '#888', fontSize: 12 }}>Imposto estimado ({impostosPercentual}%): {fmtMoeda(valorImpostos)} <span style={{ fontSize: 11 }}>(informativo)</span></div>}
            <div style={{ fontSize: 16, marginTop: 4 }}>Total: <strong style={{ color: '#0099FF' }}>{fmtMoeda(total)}</strong></div>
          </div>
        )}
      </Card>

      <Card title={`Boletos (${boletos.length})`} size="small" style={{ marginBottom: 16 }}
        extra={<Button type="primary" icon={<DollarOutlined />} onClick={() => { formBoleto.resetFields(); setModalBoleto(true); }} disabled={!id}>Emitir Boleto</Button>}>
        <Table dataSource={boletos} rowKey="id" size="small" locale={{ emptyText: 'Nenhum boleto emitido.' }}
          columns={[
            { title: 'Ações', width: 160, render: (_, r) => (
              <Space size={2}>
                <Button size="small" icon={<FilePdfOutlined />} onClick={() => verBoleto(r.id)} title="Ver dados do boleto" />
                <Button size="small" icon={<DownloadOutlined />} style={{color:'#1a3c5e',borderColor:'#1a3c5e'}} onClick={() => baixarPDFBoleto(r.id)} title="Baixar PDF do boleto" />
                <Button size="small" icon={<MailOutlined />} onClick={() => reenviarEmail(r.id)} title="Reenviar Email" />
                <Button size="small" icon={<ReloadOutlined />} onClick={() => consultarStatus(r.id)} title="Atualizar Status" />
                {r.status === 'emitido' && <Button size="small" danger icon={<StopOutlined />} title="Cancelar" onClick={() => { setBoletoCancelarId(r.id); setMotivoCancelamento('ACERTOS'); setModalCancelar(true); }} />}
              </Space>
            )},
            { title: 'Valor', dataIndex: 'valor', width: 100, render: v => 'R$ ' + parseFloat(v).toFixed(2).replace('.', ',') },
            { title: 'Vencimento', dataIndex: 'vencimento', width: 110, render: v => v ? new Date(v).toLocaleDateString('pt-BR') : '-' },
            { title: 'Status', dataIndex: 'status', width: 100, render: v => {
              const cores = { emitido: 'blue', pago: 'green', cancelado: 'red', expirado: 'orange' };
              const labels = { emitido: 'Emitido', pago: 'Pago', cancelado: 'Cancelado', expirado: 'Expirado' };
              return <Tag color={cores[v]||'default'}>{labels[v]||v}</Tag>;
            }},
            { title: 'Email', dataIndex: 'enviado_email', width: 80, render: v => v ? <Tag color="green">Enviado</Tag> : <Tag>Pendente</Tag> },
            { title: 'Emitido em', dataIndex: 'criado_em', width: 130, render: v => v ? new Date(v).toLocaleString('pt-BR') : '-' },
          ]}
        />
      </Card>

      <Card title={`Notas Fiscais (${nfes.length})`} size="small" style={{ marginBottom: 16 }}
        extra={<Button type="primary" icon={<FileProtectOutlined />} onClick={abrirModalNFe} disabled={!id}>Emitir NF-e</Button>}>
        <Table dataSource={nfes} rowKey="id" size="small" pagination={false}
          locale={{ emptyText: 'Nenhuma NF-e emitida.' }}
          columns={[
            { title: 'Nº', dataIndex: 'numero', width: 60, render: v => <Tag color="blue">{v}</Tag> },
            { title: 'Ações', width: 180, render: (_, r) => (
              <Space size={4}>
                <Button size="small" icon={<FilePdfOutlined />} title="DANFE" onClick={async () => {
                  try {
                    const res = await api.get('/nfe/' + r.id + '/danfe', { responseType: 'blob' });
                    const url = URL.createObjectURL(new Blob([res.data], { type: 'application/pdf' }));
                    window.open(url, '_blank');
                  } catch { message.error('Erro ao gerar DANFE'); }
                }} />
                <Button size="small" icon={<DownloadOutlined />} title="Baixar XML" onClick={async () => {
                  try {
                    const res = await api.get('/nfe/' + r.id + '/xml', { responseType: 'blob' });
                    const url = URL.createObjectURL(new Blob([res.data]));
                    const a = document.createElement('a'); a.href = url; a.download = 'NFe-' + r.chave_acesso + '.xml'; a.click();
                  } catch { message.error('Erro ao baixar XML'); }
                }} />
                {r.status === 'autorizada' && <Button size="small" icon={<PlusOutlined />} title="NF-e Complementar" onClick={() => abrirComplementar(r)} />}
                {r.status === 'autorizada' && <Button size="small" icon={<EditOutlined />} title="Carta de Correção" onClick={async () => {
                  const correcao = prompt('Descrição da correção (mínimo 15 caracteres):');
                  if (!correcao || correcao.length < 15) { message.warning('Correção deve ter pelo menos 15 caracteres'); return; }
                  try {
                    await api.post('/nfe/' + r.id + '/carta-correcao', { xCorrecao: correcao });
                    message.success('Carta de Correção enviada!');
                  } catch(e) { message.error('Erro: ' + (e.response?.data?.erro || e.message)); }
                }} />}
                {r.status === 'autorizada' && <Button size="small" danger icon={<StopOutlined />} title="Cancelar" onClick={async () => {
                  const motivo = prompt('Motivo do cancelamento (mínimo 15 caracteres):');
                  if (!motivo || motivo.length < 15) { message.warning('Motivo deve ter pelo menos 15 caracteres'); return; }
                  try {
                    await api.post('/nfe/' + r.id + '/cancelar', { motivo });
                    const rn = await api.get('/nfe/proposta-produto/' + id);
                    setNfes(rn.data || []);
                    message.success('NF-e cancelada!');
                  } catch(e) { message.error('Erro: ' + (e.response?.data?.erro || e.message)); }
                }} />}
              </Space>
            )},
            { title: 'Chave', dataIndex: 'chave_acesso', ellipsis: true },
            { title: 'Status', dataIndex: 'status', width: 100, render: v => <Tag color={v==='autorizada'?'green':v==='cancelada'?'red':'orange'}>{v}</Tag> },
            { title: 'Emitida em', dataIndex: 'criado_em', width: 120, render: v => v ? new Date(v).toLocaleDateString('pt-BR') : '-' },
          ]}
        />
      </Card>

      <Modal title="Emitir NF-e" open={modalNFe} onCancel={() => setModalNFe(false)}
        onOk={emitirNFe} okText="Emitir NF-e" confirmLoading={emitindoNFe} okButtonProps={{ type: 'primary' }}>
        <div style={{ padding: 12, background: '#f6ffed', border: '1px solid #b7eb8f', borderRadius: 6, marginBottom: 12 }}>
          <strong>{'Aten\u00e7\u00e3o:'}</strong>{' esta NF-e ser\u00e1 emitida em PRODU\u00c7\u00c3O e ter\u00e1 valor fiscal.'}
        </div>
        <p>Confirma a emissão da NF-e para a proposta <strong>{proposta?.numero}</strong>?</p>
        <p>Valor: <strong>{fmtMoeda(total)}</strong></p>
        <p>Cliente: <strong>{proposta?.razao_social || proposta?.nome_cliente}</strong></p>
        <div style={{ marginTop: 12 }}>
          <label style={{ fontSize: 12, color: '#888' }}>Informações Adicionais</label>
          <Input.TextArea rows={3} value={infAdic} onChange={e => setInfAdic(e.target.value)} placeholder="Informações adicionais da nota..." />
        </div>
        <div style={{ marginTop: 12 }}>
          <label style={{ fontSize: 12, color: '#888' }}>Informações Adicionais</label>
        </div>
        <Divider />
        <div style={{ padding: 12, background: '#f6ffed', border: '1px solid #b7eb8f', borderRadius: 6, marginBottom: 12 }}>
          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 8 }}>
            <strong>Movimentar Estoque?</strong>
            <Select value={movimentarEstoque} onChange={setMovimentarEstoque} style={{ width: 100 }}>
              <Option value={false}>Não</Option>
              <Option value={true}>Sim</Option>
            </Select>
          </div>
          {movimentarEstoque && (
            <div>
              <label style={{ fontSize: 12, color: '#888' }}>Depósito de Saída</label>
              <Select style={{ width: '100%' }} value={depositoNFe} onChange={setDepositoNFe}>
                {depositos.map(d => <Option key={d.id} value={d.id}>{d.nome}</Option>)}
              </Select>
            </div>
          )}
        </div>
        {nfesCanceladas.length > 0 && (
          <div style={{ marginTop: 16, padding: 12, background: '#fff2e8', border: '1px solid #ffbb96', borderRadius: 6 }}>
            <p><strong>Existem NF-e(s) canceladas para esta proposta. Deseja emitir como substituta?</strong></p>
            <Select style={{ width: '100%' }} placeholder="Selecione a NF-e cancelada a substituir (opcional)" allowClear onChange={setChaveSubstituta}>
              {nfesCanceladas.map(n => <Option key={n.id} value={n.chave_acesso}>NF-e {n.numero} — Chave: {n.chave_acesso?.substring(0,20)}...</Option>)}
            </Select>
          </div>
        )}
      </Modal>

      <Card size="small" title="Observações">
        <TextArea rows={4} value={observacoes} onChange={e => setObservacoes(e.target.value)} placeholder="Observações adicionais para a proposta..." />
      </Card>
    <Modal title="Emitir Boleto" open={modalBoleto} onCancel={() => setModalBoleto(false)} footer={null} width={560}>
      <Form form={formBoleto} layout="vertical" onFinish={emitirBoleto}
        initialValues={{ multa_percentual: 5, juros_percentual: 2, desconto_percentual: 0, tipo_boleto: 'unico', fim_recorrencia: 'nunca', codigo_controle: proposta?.numero, descricao: proposta?.titulo }}>
        <Row gutter={12}>
          <Col span={12}><Form.Item name="codigo_controle" label="Código de Controle"><Input /></Form.Item></Col>
          <Col span={12}><Form.Item name="descricao" label="Descrição"><Input /></Form.Item></Col>
        </Row>
        <Form.Item name="tipo_boleto" label="Tipo de Boleto" rules={[{ required: true }]}>
          <Select>
            <Option value="unico">Único</Option>
            <Option value="recorrente">Recorrente</Option>
            <Option value="parcelado">Parcelado</Option>
          </Select>
        </Form.Item>
        <Form.Item name="valor" label={`Valor (padrão: R$ ${parseFloat(total||0).toFixed(2).replace('.',',')})`}>
          <Input type="number" step="0.01" placeholder="Deixe vazio para usar valor da proposta" />
        </Form.Item>
        <Form.Item shouldUpdate={(prev, curr) => prev.tipo_boleto !== curr.tipo_boleto} noStyle>
          {({ getFieldValue }) => {
            const tipo = getFieldValue('tipo_boleto');
            return <>
              {(tipo === 'unico' || tipo === 'parcelado') && (
                <Form.Item name="vencimento" label="Data de Vencimento" rules={[{ required: true }]}>
                  <DatePicker format="DD/MM/YYYY" style={{ width: '100%' }} />
                </Form.Item>
              )}
            </>;
          }}
        </Form.Item>
        <Row gutter={12}>
          <Col span={8}><Form.Item name="multa_percentual" label="Multa (%)"><Input type="number" step="0.01" /></Form.Item></Col>
          <Col span={8}><Form.Item name="juros_percentual" label="Juros ao mês (%)"><Input type="number" step="0.01" /></Form.Item></Col>
          <Col span={8}><Form.Item name="desconto_percentual" label="Desconto (%)"><Input type="number" step="0.01" /></Form.Item></Col>
        </Row>
        <Button type="primary" htmlType="submit" loading={gerandoBoleto} icon={<DollarOutlined />} block>Emitir e Enviar</Button>
      </Form>
    </Modal>
    <Modal title="Cancelar Boleto" open={modalCancelar} onCancel={() => setModalCancelar(false)} onOk={cancelarBoleto} okText="Cancelar Boleto" okButtonProps={{ danger: true }} cancelText="Voltar">
      <p style={{ marginBottom: 12 }}>Selecione o motivo do cancelamento:</p>
      <Select value={motivoCancelamento} onChange={setMotivoCancelamento} style={{ width: '100%' }}>
        <Option value="ACERTOS">Acertos</Option>
        <Option value="PAGODIRETOAOCLIENTE">Pago direto ao cliente</Option>
        <Option value="SUBSTITUICAO">Substituição</Option>
      </Select>
    </Modal>
    <Modal title="Dados do Boleto" open={modalDadosBoleto} onCancel={() => setModalDadosBoleto(false)} footer={<Button onClick={() => setModalDadosBoleto(false)}>Fechar</Button>} width={680}>
      {dadosBoleto && (
        <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
          <div><strong>Valor:</strong> R$ {parseFloat(dadosBoleto.valor||0).toFixed(2).replace('.',',')}</div>
          <div><strong>Vencimento:</strong> {dadosBoleto.vencimento ? new Date(dadosBoleto.vencimento).toLocaleDateString('pt-BR') : '-'}</div>
          <div><strong>Nosso Número:</strong> {dadosBoleto.nosso_numero}</div>
          <div><strong>Linha Digitável:</strong><Input.Search value={dadosBoleto.linha_digitavel} readOnly enterButton="Copiar" onSearch={() => { navigator.clipboard.writeText(dadosBoleto.linha_digitavel); message.success('Copiado!'); }} /></div>
          <div><strong>Código de Barras:</strong><Input.Search value={dadosBoleto.codigo_barras} readOnly enterButton="Copiar" onSearch={() => { navigator.clipboard.writeText(dadosBoleto.codigo_barras); message.success('Copiado!'); }} /></div>
          {dadosBoleto.pix_copia_cola && <div><strong>PIX Copia e Cola:</strong><Input.Search value={dadosBoleto.pix_copia_cola} readOnly enterButton="Copiar" onSearch={() => { navigator.clipboard.writeText(dadosBoleto.pix_copia_cola); message.success('Copiado!'); }} /></div>}
        </div>
      )}
    </Modal>
    <Modal title="NF-e Complementar" open={modalComplementar} onCancel={() => setModalComplementar(false)}
        onOk={emitirComplementar} okText="Emitir Complementar" confirmLoading={emitindoComplementar} width={700}>
      <p style={{ marginBottom: 12 }}>Itens complementares para NF-e <strong>{nfeSelecionada?.numero}</strong>:</p>
      {itensComplementar.map((it, idx) => (
        <div key={idx} style={{ padding: 8, background: '#f9f9f9', borderRadius: 6, marginBottom: 8 }}>
          <Row gutter={8} style={{ marginBottom: 6 }}>
            <Col span={20}>
              <label style={{ fontSize: 11, color: '#888' }}>Produto</label>
              {it.avulso ? (
                <Input placeholder="Descrição do item avulso" value={it.descricao} onChange={e => { const n=[...itensComplementar]; n[idx].descricao=e.target.value; setItensComplementar(n); }} />
              ) : (
                <Select showSearch optionFilterProp="children" style={{ width: '100%' }} value={it.produto_id} allowClear placeholder="Selecione o produto"
                  onChange={v => { const n=[...itensComplementar]; const prod=produtosComplementar.find(p=>p.id===v); if(prod){ n[idx].produto_id=v; n[idx].descricao=prod.descricao; n[idx].unidade=(prod.unidade||'UN').substring(0,6); n[idx].preco_unitario=prod.preco_venda||0; n[idx].ncm=(prod.ncm||'').replace(/\D/g,''); n[idx].origem=prod.origem||0; } setItensComplementar(n); }}>
                  {produtosComplementar.map(p => <OptionComp key={p.id} value={p.id}>{p.descricao} {p.ncm ? '(NCM: '+p.ncm+')' : ''}</OptionComp>)}
                </Select>
              )}
            </Col>
            <Col span={4} style={{ paddingTop: 18 }}>
              <Space direction="vertical" style={{ width: '100%' }}>
                <Button size="small" block onClick={() => { const n=[...itensComplementar]; n[idx].avulso=!n[idx].avulso; n[idx].produto_id=null; n[idx].descricao=''; n[idx].ncm=''; setItensComplementar(n); }}>{it.avulso ? 'Usar cadastro' : 'Item avulso'}</Button>
                <Button danger size="small" block onClick={() => setItensComplementar(itensComplementar.filter((_,i)=>i!==idx))}>Remover</Button>
              </Space>
            </Col>
          </Row>
          <Row gutter={8}>
            <Col span={6}><label style={{ fontSize: 11, color: '#888' }}>Quantidade</label><InputNumber style={{width:'100%'}} min={0} value={it.quantidade} onChange={v => { const n=[...itensComplementar]; n[idx].quantidade=v; setItensComplementar(n); }} /></Col>
            <Col span={6}><label style={{ fontSize: 11, color: '#888' }}>Unidade</label><Input value={it.unidade} onChange={e => { const n=[...itensComplementar]; n[idx].unidade=e.target.value; setItensComplementar(n); }} /></Col>
            <Col span={6}><label style={{ fontSize: 11, color: '#888' }}>Valor unitário (R$)</label><InputNumber style={{width:'100%'}} min={0} precision={2} decimalSeparator="," value={it.preco_unitario} onChange={v => { const n=[...itensComplementar]; n[idx].preco_unitario=v; setItensComplementar(n); }} /></Col>
            <Col span={6}><label style={{ fontSize: 11, color: '#888' }}>NCM</label><Input value={it.ncm} onChange={e => { const n=[...itensComplementar]; n[idx].ncm=e.target.value; setItensComplementar(n); }} /></Col>
          </Row>
        </div>
      ))}
      <Button icon={<PlusOutlined />} onClick={() => setItensComplementar([...itensComplementar, { produto_id: null, descricao: '', quantidade: 1, unidade: 'UN', preco_unitario: 0, ncm: '', origem: 0, avulso: false }])} style={{ marginBottom: 12 }}>Adicionar Item</Button>
      <div>
        <label style={{ fontSize: 12, color: '#888' }}>Informações Adicionais</label>
        <Input.TextArea rows={2} value={infAdicComplementar} onChange={e => setInfAdicComplementar(e.target.value)} />
      </div>
    </Modal>
    </div>
  );
}
